import { useSelector } from "react-redux";

import { createNodeSelector } from "../contextualSelectors/index.ts";

export const useCreateNode = () => useSelector(createNodeSelector);
